<template>
	<CommonForm :formData="formData">
		<!-- <el-col :span="7" class="col-h">
			<el-form-item label="深度转化" prop="deep" >
				<el-switch v-model="formData.deep" />
			</el-form-item>
		</el-col> -->
		<el-col :span="7" class="col-h">
			<el-form-item label="转化目标" prop="target" >
				<el-select v-model="formData.target" placeholder="请选择转化目标" @change="handleTargetChange">
					<el-option v-for="item in global.conversionNameList" :key="item.value" :label="item.label" :value="item.value" />
				</el-select>
			</el-form-item>
		</el-col>
		<el-col :span="7" class="col-h">
			<el-form-item label="转化出价"  :rules="moneyRules" prop="cost">
				<el-input v-model="formData.cost" placeholder="请输入价格" @input="(value)=>handleInput('cost', value)" />
			</el-form-item>
			<div class="form-item__tip" v-if="priceAvg">
				<TipInfo :data="priceAvg"/>
			</div>
		</el-col>
		<el-col :span="7" class="col-h" v-if="main.deepConversionNames.length">
			<el-form-item label="深度转化" prop="deep" >
				<el-switch v-model="formData.deep"  @change="(value)=>handleSwitchChange(value, 'deep')"/>
			</el-form-item>
		</el-col>
		<slot/>
	</CommonForm>
</template>

<script>
import CommonForm from './commonForm.vue'
import { validNum } from '@/utils/validate'
import { numStrip } from '@/utils'
import TipInfo from './tipInfo'
export default {
	inject: [ 'global' , 'moneyRules', 'main'],
	components: { CommonForm , TipInfo},
	props: ["formData"],
	data() {
		return {
			priceAvg: '', // 出价均值
			
		}
	},
	computed: {
		
		
	},
	methods: {
		handleSwitchChange(value, key) {
			// powerful deep 互斥
			if(value) {
				this.$set(this.formData, 'powerful', false);
				this.$set(this.formData, 'powerfulName', '');
				this.$set(this.formData, 'coef_low', '');
				this.$set(this.formData, 'coef_tall', '');
			}else {
				this.$set(this.formData, 'deepTarget', '');
				this.$set(this.formData, 'deepCost', '');
			}
		},
		handleTargetChange(keys) {
			this.formData.deep = false;
			this.$set(this.formData, 'deepTarget', '');
			this.$set(this.formData, 'deepCost', '');
		},
		handleInput(key, value) {
			if(!validNum(value)) {
				this.priceAvg = ''
				return 
			}
			const num = this.global.handleValidNumber(value) || value;
			if (num) {
				this.formData[key] = num;
			}
			this.avgValue(this.formData[key]);
		},
		async avgValue(value) {
			if(!value) {
				return
			}
			const params = {
				pay_type: this.formData.way,
				conv_type: this.formData.target,
			};
			if(!this.formData.target) {
				return
			}
			const result = await this.global.getBatchConversionPrice(params);
			if(!result.ocpx_price_avg) {
				this.priceAvg = '';
				return
			}
			const n = numStrip(value - result.ocpx_price_avg);
			if (n>0) {
				this.priceAvg = `高${n}`;
			}else if(n === 0) {
				this.priceAvg = `${n}`;
			}else {
				this.priceAvg = `低${-n}`;
			}
		}
	},
	watch: {
		
	}
}
</script>

<style lang="scss" scoped>
.col-h {
	min-height: 52px;
}
.row-box {
	border: 1px solid #dcdfe6;
	margin: 0 12px 20px;
	border-radius: 8px;
	padding-top: 20px;
	position: relative;
}
.border-title {
	position: absolute;
	top: -8px;
	left: 20px;
	color: #606266;
	background: #fff;
}
.form-item__tip {
	margin-top: -16px;
	margin-left: 100px;
	color: #666;
	font-size: 12px;
}
</style>